import styled, { ITheme } from '../../../theme'

const ArrowButton = styled.div`
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  background-color: ${(props: ITheme) =>
    props.theme.colors.palette.pinkishGrey};
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  text-align: center;
  &:hover {
    background-color: ${(props: ITheme) =>
      props.theme.colors.palette.slateGrey};
  }
`

export default ArrowButton
